const tokenFromBrand = {
  1: 'oeskTJnioMax4BsXpaHMxhem',
  2: 'Rx7FaiH5Bc6UDBucGjizK6iL',
  4: 'jDwfw1RvxdwbtMfYjvm3eB1h'
}

const maintenanceToken = 'SARLHy2gfnneHvc3JhTucjra';

const LinkingPos = ({ amount, code, brandId }) => {
    const token = brandId ? tokenFromBrand[brandId] : maintenanceToken;

    return (
      <iframe
        title="Pago"
        src={`https://linkingpos.com/external_payments/new?access_token=${token}&import=${amount}&client_ref=${code}`}
        style={{ width: "100%", height: "550px", overflowY: "hidden" }}
        scrolling="no"
        frameBorder="0"
      ></iframe>
    );
  };
  
  export default LinkingPos;
  